var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 155.62 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m38,17l9,3.16v9.84l-9-1.76v-11.24Z",
    fill: "#87d6f8",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m38,55.76v11.24l9-3.16v-9.84l-9,1.76Z",
    fill: "#f26722",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m38,28v28l9-1.74v-24.52l-9-1.74Z",
    fill: "#00aa81",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m11,61.59V22.41L0,20v44l11-2.41Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m38,66.77V17.13l-18-6.13v62l18-6.23Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m108.6,33.42v8.56h-4.18v-8.2c0-1.39-.67-2.29-2-2.29s-2.17.98-2.17,2.62v7.86h-4.18v-8.2c0-1.39-.67-2.29-2-2.29s-2.17.98-2.17,2.62v7.86h-4.18v-13.94h4.18v1.28c.64-.95,1.86-1.67,3.73-1.67,1.64,0,2.87.67,3.65,1.84.78-1.12,2.06-1.84,4.04-1.84,3.2,0,5.29,2.29,5.29,5.77h0Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m118.54,38.63c1.14,0,2.12-.44,2.67-1.06l3.34,1.92c-1.36,1.9-3.43,2.87-6.07,2.87-4.76,0-7.71-3.21-7.71-7.36s3.01-7.36,7.4-7.36c4.06,0,7.07,3.15,7.07,7.36,0,.59-.05,1.14-.17,1.67h-9.88c.53,1.45,1.81,1.95,3.34,1.95h0Zm2.56-5.07c-.45-1.62-1.7-2.2-2.95-2.2-1.59,0-2.65.78-3.04,2.2h5.99Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m132.49,32.06v4.94c0,1.2,1.03,1.31,2.87,1.2v3.79c-5.46.56-7.04-1.09-7.04-4.99v-4.94h-2.23v-4.01h2.23v-2.65l4.18-1.25v3.9h2.87v4.01h-2.87Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m137.3,24.3c0-1.37,1.14-2.51,2.51-2.51s2.51,1.14,2.51,2.51-1.14,2.51-2.51,2.51-2.51-1.14-2.51-2.51Zm.42,3.74h4.18v13.94h-4.18v-13.94Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m155.62,37.8c0,3.21-2.78,4.57-5.79,4.57-2.78,0-4.9-1.06-5.99-3.32l3.62-2.06c.36,1.06,1.14,1.64,2.37,1.64,1,0,1.5-.31,1.5-.86,0-1.53-6.85-.73-6.85-5.55,0-3.04,2.56-4.57,5.46-4.57,2.25,0,4.26,1,5.43,2.98l-3.56,1.92c-.39-.73-.95-1.23-1.87-1.23-.72,0-1.17.28-1.17.78,0,1.59,6.85.53,6.85,5.69h0Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m96.23,47.69v7.68c0,2.42-1.79,3.79-4.01,3.79-1.88,0-3.22-.76-3.8-1.94l.71-.4c.42.85,1.32,1.56,3.09,1.56,2.01,0,3.21-1.18,3.21-3.02v-1.48c-.66,1.24-1.9,2.05-3.46,2.05-2.3,0-4.17-1.82-4.17-4.21s1.87-4.21,4.17-4.21c1.56,0,2.8.81,3.46,2.05v-1.87h.81Zm-.81,4.03c0-1.92-1.5-3.44-3.42-3.44s-3.42,1.52-3.42,3.44,1.5,3.44,3.42,3.44,3.42-1.52,3.42-3.44Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m102.2,47.58v.77c-1.39,0-2.69.85-2.69,2.92v4.48h-.81v-8.07h.81v1.58c.55-1.28,1.6-1.69,2.69-1.69h0Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m102.8,51.72c0-2.39,1.88-4.21,4.24-4.21s4.22,1.82,4.22,4.21-1.88,4.21-4.22,4.21-4.24-1.82-4.24-4.21Zm7.64,0c0-1.92-1.48-3.44-3.4-3.44s-3.42,1.52-3.42,3.44,1.5,3.44,3.42,3.44,3.4-1.52,3.4-3.44Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m119.8,47.69v8.07h-.81v-1.53c-.61,1.19-1.64,1.71-2.88,1.71-1.92,0-3.13-1.28-3.13-3.23v-5.02h.82v5.02c0,1.48.85,2.45,2.37,2.45s2.82-1.03,2.82-3.21v-4.26h.81Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m130.72,51.72c0,2.39-1.87,4.21-4.17,4.21-1.56,0-2.8-.81-3.46-2.05v5.1h-.81v-11.29h.81v1.87c.66-1.24,1.9-2.05,3.46-2.05,2.31,0,4.17,1.82,4.17,4.21h0Zm-.81,0c0-1.92-1.5-3.44-3.42-3.44s-3.42,1.52-3.42,3.44,1.5,3.44,3.42,3.44,3.42-1.52,3.42-3.44Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m47,0l23,15.74v52.52l-23,15.74V0Z",
    fill: "#fff",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.655b2e2bc5e1afdf484c29d4bb91b02c.svg";
export { ForwardRef as ReactComponent };